export const programs_shopper = {
  logo: "https://d2guulkeunn7d8.cloudfront.net/assets/footer/shopper-footer-v3-7e5a506c6d7f915192f8db4a5aa1b9a035f2612eb609988031e35d1573e66c0e.svg",
  slogan: "Become a Shopper",
  arr: [
    {
      title: "Make money with us",
      body: [
        "Shopper Opportunities",
        "Become a Shopper",
        "In-Store Employee For Instacart",
        "Earnings"
      ],
    },
    {
      title: "Top cities",
      body: [
        "Los Angeles",
        "New York City",
        "Chicago",
        "Washington D.C.",
        "San Francisco"
      ],
    },
    {
      title: "More cities",
      body: [
        "Miami",
        "Las Vegas",
        "Atlanta",
        "Dallas",
        "View all Job Locations"
      ],
    },
    {
      title: "Shopper help",
      body: [
        "Help",
        "Contact",
        "Safety"
      ],
    },
  ],
};
